import {Box, Typography} from '@mui/material';
import './DocPresentationSequence.scss';
import {t} from 'i18next';
import ArrCheckbox from '../../../common/arr-checkbox/ArrCheckbox';
import ArrSingleSelectDropdown from '../../../common/arr-select-dropdown/ArrSingleSelectDropdown';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../../../../redux/store';
import {ISelectItem} from '../../../../shared/types';
import {
  setSelectedMetaDataDirection,
  setSelectedMetaDataFieldId,
  setMetaDatChkForFamilyTogether,
  setMetaDataChkForEmailsTogether,
} from '../../../../redux/slice/assignmentSlice';

const metaDataDirectionOptions: ISelectItem[] = [
  {key: true, value: 'Ascending'},
  {key: false, value: 'Descending'},
];
const SortByMetaData = () => {
  const i18Path = 'assignment.new.docSequence.sortByMetadata';
  const dispatch = useDispatch();

  const docSorting = useSelector(
    (state: RootState) =>
      state.assignment.formData?.assignmentModel?.docPresentationSorting
  );
  const {parentAssignmentGroupID} = useSelector(
    (state: RootState) => state.assignment.formData?.assignmentModel
  );
  const treeData = useSelector(
    (state: RootState) => state.assignment.assignmentTree
  );
  const isParentCascaseEnabled = treeData?.find(
    (item) => +item.id === parentAssignmentGroupID
  )?.li_attr.isCascadeEnabled;
  const selectedMetaDataFieldId = docSorting?.selectedMetaDataFieldId ?? null;
  const selectedMetaDataDirection = docSorting?.metaDataDirection ?? null;
  const metaDatChkForFamilyTogether =
    docSorting?.metadatChkForFamilyTogether ?? true;
  const metaDataChkForEmailsTogether =
    docSorting?.metadataChkForEmailsTogether ?? true;

  const selectedDirectionOption: ISelectItem | null =
    metaDataDirectionOptions.find(
      (opt) => opt.key === selectedMetaDataDirection
    ) ?? null;

  const rawMetaData = useSelector(
    (state: RootState) =>
      state.assignment.listData?.docPresentationSorting?.lstMetaDataFieldModel
  );

  const lstMetaDataFieldModel =
    rawMetaData?.map((item) => ({key: item.fieldId, value: item.fieldName})) ??
    [];

  const selectedFieldOption: ISelectItem | null =
    lstMetaDataFieldModel.find((opt) => opt.key === selectedMetaDataFieldId) ??
    null;
  const handleFamiliesCheckbox = (value: boolean) => {
    dispatch(setMetaDatChkForFamilyTogether(value));
  };
  const handleEmailCheckbox = (value: boolean) => {
    dispatch(setMetaDataChkForEmailsTogether(value));
  };

  const onMetaDataFieldSelect = (item: ISelectItem | null) => {
    if (item) {
      dispatch(setSelectedMetaDataFieldId(item.key as number));
    }
  };

  const onMetaDataDirectionSelect = (item: ISelectItem | null) => {
    if (item) {
      dispatch(setSelectedMetaDataDirection(item.key as boolean));
    }
  };

  return (
    <Box className="sort-by-metadata-container">
      <Typography
        className="typo-text body3_size description"
        data-testid={`sort-by-meta-data-description`}
      >
        {t(`${i18Path}.description`)}
      </Typography>
      <Box className="dropdown-container">
        <ArrSingleSelectDropdown
          dropdownLabel="Select"
          dropdownItems={lstMetaDataFieldModel}
          selectedValues={selectedFieldOption}
          dropdownItemKey="key"
          dropdownItemDisplay="value"
          onSelectionChange={onMetaDataFieldSelect}
          dataTestId="asd-sort-by-metadata-fieldId"
          sizeVariant="medium"
          customWidth={22}
          disabled={isParentCascaseEnabled}
          clearSelection
        />
        <ArrSingleSelectDropdown
          dropdownLabel="Select"
          dropdownItems={metaDataDirectionOptions}
          selectedValues={selectedDirectionOption}
          dropdownItemKey={'key'}
          dropdownItemDisplay={'value'}
          onSelectionChange={onMetaDataDirectionSelect}
          dataTestId="asd-sort-by-metadata-direction"
          sizeVariant="medium"
          customWidth={22}
          disabled={isParentCascaseEnabled}
          clearSelection
        />
      </Box>
      <Box className="checkbox-container">
        <Box className="checkbox-label">
          <ArrCheckbox
            checked={metaDatChkForFamilyTogether}
            onChange={handleFamiliesCheckbox}
            data-testid="checkbox-2"
            disabled={isParentCascaseEnabled}
            aria-label="select-handle-family"
          ></ArrCheckbox>
          <Typography
            className="typo-text body3_size"
            data-testid={`sort-by-meta-data-family-textt`}
          >
            {t(`${i18Path}.checkbox1`)}
          </Typography>
        </Box>
        <Box className="checkbox-label">
          <ArrCheckbox
            checked={metaDataChkForEmailsTogether}
            onChange={handleEmailCheckbox}
            data-testid="checkbox-1"
            disabled={isParentCascaseEnabled}
            aria-label="select-email"
          ></ArrCheckbox>
          <Typography
            className="typo-text body3_size"
            data-testid={`sort-by-meta-data-email-text`}
          >
            {t(`${i18Path}.checkbox2`)}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default SortByMetaData;
